if (!customElements.get('cart-theoric')) {
  customElements.define('cart-theoric', class CartTheoric extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelector('#CartTheoric-Overlay').addEventListener('click', this.close.bind(this));
      this.setHeaderCartIconAccessibility();

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.handleCartUpdateEvent.bind(this));
      }

      // Mobile quantity select handler (event delegation)
      this.addEventListener('change', (e) => {
        if (e.target.classList.contains('theoric__qty-select')) {
          this.handleMobileQuantityChange(e.target);
        }
      });
    }

    setHeaderCartIconAccessibility() {
      const cartLink = document.querySelector('#cart-icon-bubble');
      if (!cartLink) return;

      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }

    open(triggeredBy) {
      // Com o carrinho do Kaching na pagina, quem abre e ele: esta gaveta fica inativa
      // (sem isso as duas abriam juntas ao clicar no icone ou adicionar um item).
      if (document.querySelector('kaching-cart')) return;
      if (triggeredBy) this.setActiveElement(triggeredBy);
      const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
      if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

      this.classList.add('active');

      this.addEventListener(
        'transitionend',
        () => {
          const containerToTrapFocusOn = this.classList.contains('is-empty')
            ? this.querySelector('.drawer__inner-empty')
            : document.getElementById('CartTheoric');
          const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
          trapFocus(containerToTrapFocusOn, focusElement);
        },
        { once: true }
      );

      this.initCheckboxToggle();
      this._enableDrawerScrollLock();
    }

    close() {
      this.classList.remove('active');
      removeTrapFocus(this.activeElement);
      this._disableDrawerScrollLock();

    }

    _enableDrawerScrollLock() {
      if (this._scrollLocked) return;
      this._scrollLocked = true;
      this._savedScrollY = window.scrollY;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this._savedScrollY}px`;
      document.body.style.width = '100%';
    }

    _disableDrawerScrollLock() {
      if (!this._scrollLocked) return;
      this._scrollLocked = false;
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, this._savedScrollY || 0);
    }

    setSummaryAccessibility(cartDrawerNote) {
      cartDrawerNote.setAttribute('role', 'button');
      cartDrawerNote.setAttribute('aria-expanded', 'false');

      if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
        cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
      }

      cartDrawerNote.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
      });

      cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }

    // ===========================================================================
    // QUIZ SECTION — Always visible (checkbox removed)
    // ===========================================================================

    initCheckboxToggle() {
      // Quiz recommendations are always visible — ensure toggle state is 'on'
      sessionStorage.setItem('theoric_quiz_toggle', 'on');
      sessionStorage.removeItem('theoric_quiz_items_backup');
    }

    async refreshDrawerSections() {
      const sectionsToRender = ['cart-theoric', 'cart-icon-bubble'];
      const response = await fetch(`${routes.cart_url}?sections=${sectionsToRender.join(',')}`);
      const responseJson = await response.json();

      const cartTheoricHtml = responseJson['cart-theoric'];
      if (cartTheoricHtml) {
        const html = new DOMParser().parseFromString(cartTheoricHtml, 'text/html');
        const newCartTheoric = html.querySelector('cart-theoric');

        if (newCartTheoric) {
          const newDrawerInner = newCartTheoric.querySelector('.drawer__inner');
          const currentDrawerInner = this.querySelector('.drawer__inner');
          if (newDrawerInner && currentDrawerInner) {
            currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
          }

          // Re-bind overlay click
          const overlay = this.querySelector('#CartTheoric-Overlay');
          if (overlay) overlay.addEventListener('click', this.close.bind(this));

          // Re-init checkbox after replacing the drawer markup.
          this.initCheckboxToggle();
        }
      }

      // Update cart icon bubble
      const cartBubbleHtml = responseJson['cart-icon-bubble'];
      const cartBubbleElement = document.getElementById('cart-icon-bubble');
      if (cartBubbleElement && cartBubbleHtml) {
        cartBubbleElement.innerHTML = this.getSectionInnerHTML(cartBubbleHtml, '.shopify-section');
      }
    }

    // ===========================================================================
    // MOBILE QUANTITY SELECT
    // ===========================================================================

    async handleMobileQuantityChange(select) {
      const index = select.dataset.index;
      const quantity = parseInt(select.value, 10);

      try {
        const body = JSON.stringify({
          line: index,
          quantity: quantity,
          sections: 'cart-theoric,cart-icon-bubble',
          sections_url: window.location.pathname
        });

        await fetch(`${routes.cart_change_url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body
        });

        await this.refreshDrawerSections();
      } catch (error) {
        console.error('[CartTheoric] Mobile qty change error:', error);
      }
    }

    // ===========================================================================
    // RENDER / UPDATE METHODS
    // ===========================================================================

    renderContents(parsedState) {
      const drawerInner = this.querySelector('.drawer__inner');
      if (drawerInner) drawerInner.classList.remove('is-empty');

      this.productId = parsedState.id;

      try {
        this.getSectionsToRender().forEach((section) => {
          const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);

          if (!sectionElement) return;

          const sectionHtml = parsedState.sections[section.id];
          if (!sectionHtml) return;

          sectionElement.innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
        });
      } catch (e) {
        console.error('[CartTheoric] Erro ao renderizar seções:', e);
      }

      setTimeout(() => {
        const overlay = this.querySelector('#CartTheoric-Overlay');
        if (overlay) overlay.addEventListener('click', this.close.bind(this));
        this.initCheckboxToggle();
        // Não abre o drawer — apenas anima o ícone da bolsa
        this.animateCartIcon();
      });
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    async handleCartUpdateEvent(event) {
      if (event.source === 'product-form') return;

      // CartTheoricItems.updateQuantity() already replaced innerHTML —
      // just re-init checkbox, skip redundant fetch.
      if (event.source === 'cart-items') {
        this.initCheckboxToggle();
        return;
      }

      try {
        const cartDataResponse = await fetch('/cart.js');
        const cartData = await cartDataResponse.json();

        const sectionsToRender = ['cart-theoric', 'cart-icon-bubble'];
        const response = await fetch(`${routes.cart_url}?sections=${sectionsToRender.join(',')}`);
        const responseJson = await response.json();

        const cartTheoricHtml = responseJson['cart-theoric'];
        if (cartTheoricHtml) {
          const html = new DOMParser().parseFromString(cartTheoricHtml, 'text/html');
          const newCartTheoric = html.querySelector('cart-theoric');

          if (newCartTheoric) {
            const newDrawerInner = newCartTheoric.querySelector('.drawer__inner');
            const currentDrawerInner = this.querySelector('.drawer__inner');
            if (newDrawerInner && currentDrawerInner) {
              currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
            }

            const overlay = this.querySelector('#CartTheoric-Overlay');
            if (overlay) {
              overlay.addEventListener('click', this.close.bind(this));
            }

            this.classList.toggle('is-empty', cartData.item_count === 0);

            this.initCheckboxToggle();
          }
        }

        const cartBubbleHtml = responseJson['cart-icon-bubble'];
        const cartBubbleElement = document.getElementById('cart-icon-bubble');
        if (cartBubbleElement && cartBubbleHtml) {
          const innerHTML = this.getSectionInnerHTML(cartBubbleHtml, '.shopify-section');
          cartBubbleElement.innerHTML = innerHTML;
        }

      } catch (error) {
        console.error('[CartTheoric] Erro ao processar atualização do drawer:', error);
      }
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-theoric',
          selector: '#CartTheoric',
        },
        {
          id: 'cart-icon-bubble',
        },
      ];
    }

    getSectionDOM(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    }

    animateCartIcon() {
      const icon = document.getElementById('cart-icon-bubble');
      if (!icon) return;
      icon.classList.remove('cart-icon--bounce');
      // Force reflow to restart animation
      void icon.offsetWidth;
      icon.classList.add('cart-icon--bounce');
      icon.addEventListener('animationend', () => {
        icon.classList.remove('cart-icon--bounce');
      }, { once: true });
    }

    setActiveElement(element) {
      this.activeElement = element;
    }

  });
}

if (!customElements.get('cart-theoric-items')) {
  customElements.define('cart-theoric-items', class CartTheoricItems extends CartItems {
    getSectionsToRender() {
      return [
        {
          id: 'CartTheoric',
          section: 'cart-theoric',
          selector: '.drawer__inner',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section',
        },
      ];
    }
  });
}

(function openCartFromStorefrontReturn() {
  const url = new URL(window.location.href);
  if (url.searchParams.get('open_cart') !== '1') return;

  const drawer = document.querySelector('cart-theoric');
  if (!drawer || typeof drawer.open !== 'function') return;

  drawer.open(document.getElementById('cart-icon-bubble'));
  url.searchParams.delete('open_cart');
  window.history.replaceState(null, '', `${url.pathname}${url.search}${url.hash}`);
})();
